/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-constant-binary-expression */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState, useEffect } from "react";
import React from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Avatar,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ListItemIcon,
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  InputAdornment,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Divider,
  LinearProgress,
} from "@mui/material";
import {
  ArrowBack as ArrowBackIcon,
  Person as PersonIcon,
  CalendarToday as CalendarIcon,
  Speed as SpeedIcon,
  LocalGasStation as FuelIcon,
  History as HistoryIcon,
  BugReport as DamageIcon,
  Login as LoginIcon,
  Logout as LogoutIcon,
  FiberManualRecord as DotIcon,
  BrokenImage as BrokenIcon,
  Bolt as ImpactIcon,
  Gesture as ScratchIcon,
  RemoveCircle as MissingIcon,
  FilterList as FilterIcon,
  Search as SearchIcon,
  Clear as ClearIcon,
  CameraAlt as CameraAltIcon,
  DriveEta as DriveEtaIcon,
  MeetingRoom as MeetingRoomIcon,
  AirlineSeatReclineNormal as AirlineSeatReclineNormalIcon,
  Build as BuildIcon,
  Euro as EuroIcon,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  Warning as WarningIcon,
  CheckCircle as CheckCircleIcon,
  Schedule as ScheduleIcon,
  UploadFile as UploadFileIcon,
  LocalGasStation as LocalGasStationIcon,
  VerifiedUser as VerifiedUserIcon,
  ReportProblem as ReportProblemIcon,
  CarCrash as CarCrashIcon,
} from "@mui/icons-material";
import axios from "axios";
import { API_URL } from "../utils/api-config";
import VehicleService from "../services/VehicleService";
import type {
  VehicleHistory,
  AssignmentWithHistoricalDamages,
} from "../services/VehicleService";
import dayjs from "dayjs";
import InspectionCarousel from "../components/VehicleHistory/InspectionCarousel";
import { useAuth } from "../context/AuthContext";

// Interface pour le tableau de bord d'historique
interface HistorySummary {
  totalAssignments: number;
  completedAssignments: number;
  activeDamages: number;
  totalDamages: number;
  totalDrivers: number;
  kilometersTotal: number;
}

// Interface pour les damages
interface Damage {
  _id?: string;
  type?: string;
  face?: string;
  position?: { x: number; y: number };
  description?: string;
  responsibleDriverId?: string;
  isPreexisting?: boolean;
  images?: string[];
}

// Interface pour les processus
interface Process {
  _id?: string;
  damages?: Damage[];
  [key: string]: unknown;
}

// Interface pour les paires de processus
interface ProcessPair {
  id: string;
  entryProcess: Process | null;
  exitProcess: Process | null;
  date: string;
  driverName: string;
  purpose: string;
  status: string;
}

const VehicleHistoryPage = () => {
  const { plate, processId } = useParams<{
    plate: string;
    processId: string;
  }>();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const canAccessDashboard = hasPermission("dashboard", "read");

  const [history, setHistory] = useState<VehicleHistory | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [tabValue, setTabValue] = useState(0);
  const [processPairs, setProcessPairs] = useState<ProcessPair[]>([]);
  const [currentPair, setCurrentPair] = useState<ProcessPair | null>(null);
  const [summary, setSummary] = useState<HistorySummary>({
    totalAssignments: 0,
    completedAssignments: 0,
    activeDamages: 0,
    totalDamages: 0,
    totalDrivers: 0,
    kilometersTotal: 0,
  });

  // État pour les réparations du véhicule
  const [repairs, setRepairs] = useState<any[]>([]);
  const [loadingRepairs, setLoadingRepairs] = useState(false);

  // Ajouter l'état pour gérer le dialogue des dégâts regroupés
  const [damageDialogOpen, setDamageDialogOpen] = useState(false);
  const [selectedDamages, setSelectedDamages] = useState<any[]>([]);
  const [dialogTitle, setDialogTitle] = useState("");

  // Nouvel état pour les données historiques des dégâts
  const [historicalDamages, setHistoricalDamages] =
    useState<AssignmentWithHistoricalDamages | null>(null);
  const [loadingHistoricalDamages, setLoadingHistoricalDamages] =
    useState(false);

  // Ajouter des filtres pour les catégories de dégâts
  const [damageFilters, setDamageFilters] = useState({
    showPreexisting: true,
    showInitial: true,
    showNew: true,
  });

  // États pour recherche/filtrage/tri des processus
  const [processSearch, setProcessSearch] = useState("");
  const [processStatusFilter, setProcessStatusFilter] = useState<string>("all");
  const [processSort, setProcessSort] = useState<"date_desc" | "date_asc" | "driver" | "status">("date_desc");

  // Déterminer si on est en mode détail d'un processus ou historique général
  const isProcessDetail = Boolean(processId);

  useEffect(() => {
    const fetchVehicleHistory = async () => {
      if (!plate) return;

      setLoading(true);
      try {
        const historyData = await VehicleService.getVehicleHistory(plate);
        console.log("=== DONNÉES HISTORIQUE BRUTES ===", historyData);
        setHistory(historyData);

        // Calculer les statistiques
        const driverIds = new Set<string>();
        let completedCount = 0;
        let kmTotal = 0;

        historyData.assignments.forEach((assignment) => {
          driverIds.add(assignment.driverId);
          if (assignment.status === "terminée") {
            completedCount++;
            // Calculer les kilomètres parcourus
            if (assignment.endMileage && assignment.startMileage) {
              kmTotal += assignment.endMileage - assignment.startMileage;
            }
          }
        });

        // Calculer tous les dégâts actifs (tous les dégâts)
        const allDamages = historyData.assignments.reduce((acc, assignment) => {
          return acc + (assignment.damages?.length || 0);
        }, 0);

        setSummary({
          totalAssignments: historyData.assignments.length,
          completedAssignments: completedCount,
          activeDamages: allDamages,
          totalDamages: allDamages,
          totalDrivers: driverIds.size,
          kilometersTotal: kmTotal,
        });

        // CORRECTION: Traiter tous les assignments comme potentiellement à la fois entrée et sortie
        // On considère qu'une affectation avec initialState est toujours un processus d'entrée
        // Et une affectation avec finalState est toujours un processus de sortie

        const entryProcesses = historyData.assignments.filter(
          (a) => !!a.initialState
        );
        const exitProcesses = historyData.assignments.filter(
          (a) => !!a.finalState
        );

        console.log("=== PROCESSUS DÉTECTÉS APRÈS CORRECTION ===");
        console.log(
          "Processus d'entrée (avec initialState):",
          entryProcesses.length
        );
        console.log(
          "Processus de sortie (avec finalState):",
          exitProcesses.length
        );

        // Créer des paires basées sur les dates et les conducteurs
        // Amélioration: Créer d'abord des paires complètes lorsqu'un processus contient à la fois initialState et finalState
        const pairs: ProcessPair[] = [];

        // D'abord, identifier les processus qui contiennent à la fois initialState et finalState (processus complets)
        const completeProcesses = historyData.assignments.filter(
          (a) => !!a.initialState && !!a.finalState
        );

        console.log(
          "Processus complets (entrée+sortie):",
          completeProcesses.length
        );

        // Ajouter les processus complets en premier
        completeProcesses.forEach((process) => {
          pairs.push({
            id: process._id,
            entryProcess: process, // Le même processus pour entrée
            exitProcess: process, // et sortie car il contient les deux états
            date: process.date,
            driverName: `${process.driverFirstName} ${process.driverLastName}`,
            purpose: process.purpose || "Mission",
            status: "Complété (entrée+sortie)",
          });
        });

        // Ensuite, traiter les processus d'entrée qui n'ont pas de finalState
        entryProcesses
          .filter((entry) => !entry.finalState) // Uniquement ceux qui n'ont pas déjà été traités
          .forEach((entry) => {
            // Trouver un processus de sortie correspondant (même conducteur, date ultérieure)
            const matchingExit = exitProcesses.find(
              (exit) =>
                exit.driverId === entry.driverId &&
                !exit.initialState && // Seulement les processus qui sont uniquement de sortie
                new Date(exit.date) >= new Date(entry.date)
            );

            console.log(
              `Paire pour entrée ${entry._id}:`,
              matchingExit
                ? `sortie ${matchingExit._id}`
                : "Pas de sortie correspondante"
            );

            pairs.push({
              id: entry._id,
              entryProcess: entry,
              exitProcess: matchingExit || null,
              date: entry.date,
              driverName: `${entry.driverFirstName} ${entry.driverLastName}`,
              purpose: entry.purpose || "Mission",
              status: matchingExit ? "Complété" : "En cours",
            });
          });

        // Ajouter les processus de sortie qui n'ont pas déjà été associés à un processus d'entrée
        exitProcesses
          .filter((exit) => !exit.initialState) // Uniquement ceux qui sont purement des processus de sortie
          .forEach((exit) => {
            // Vérifier si ce processus de sortie a déjà été associé à un processus d'entrée
            const hasBeenPaired = pairs.some(
              (pair) => pair.exitProcess && pair.exitProcess._id === exit._id
            );

            if (!hasBeenPaired) {
              console.log(`Sortie sans entrée correspondante: ${exit._id}`);
              pairs.push({
                id: exit._id,
                entryProcess: null,
                exitProcess: exit,
                date: exit.date,
                driverName: `${exit.driverFirstName} ${exit.driverLastName}`,
                purpose: exit.purpose || "Mission",
                status: "Incomplet (sortie uniquement)",
              });
            }
          });

        // Trier par date
        pairs.sort(
          (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
        );
        console.log(
          "=== PAIRES CRÉÉES (triées du plus récent au plus ancien) ===",
          pairs
        );
        setProcessPairs(pairs);

        // Si on est en mode détail et qu'on a un processId, chercher la paire correspondante
        if (isProcessDetail && processId) {
          console.log(`Recherche de la paire pour le processus ${processId}`);

          const matchingPair = pairs.find((pair) => {
            const matchById = pair.id === processId;
            const matchByExitId =
              pair.exitProcess && pair.exitProcess._id === processId;
            console.log(
              `Vérification paire ${pair.id}: matchById=${matchById}, matchByExitId=${matchByExitId}`
            );
            return matchById || matchByExitId;
          });

          if (matchingPair) {
            console.log("=== PAIRE TROUVÉE ===", matchingPair);
            setCurrentPair(matchingPair);
          } else {
            console.error(
              `Aucune paire trouvée pour le processus ${processId}`
            );

            // Recherche directe dans les données brutes
            console.log(
              "Tentative de récupération directe de l'affectation..."
            );
            const directMatch = historyData.assignments.find(
              (a) => a._id === processId
            );
            if (directMatch) {
              console.log(
                "=== AFFECTATION TROUVÉE DIRECTEMENT ===",
                directMatch
              );

              // CORRECTION: Une affectation peut être à la fois entrée et sortie
              // On cherche ce qui est présent
              const hasInitialState = !!directMatch.initialState;
              const hasFinalState = !!directMatch.finalState;

              console.log(
                "A initialState:",
                hasInitialState,
                "A finalState:",
                hasFinalState
              );

              if (hasInitialState && !hasFinalState) {
                console.log("C'est un processus d'entrée uniquement");
                setCurrentPair({
                  id: directMatch._id,
                  entryProcess: directMatch,
                  exitProcess: null,
                  date: directMatch.date,
                  driverName: `${directMatch.driverFirstName} ${directMatch.driverLastName}`,
                  purpose: directMatch.purpose || "Mission",
                  status: "Processus d'entrée uniquement",
                });
              } else if (!hasInitialState && hasFinalState) {
                console.log("C'est un processus de sortie uniquement");
                setCurrentPair({
                  id: directMatch._id,
                  entryProcess: null,
                  exitProcess: directMatch,
                  date: directMatch.date,
                  driverName: `${directMatch.driverFirstName} ${directMatch.driverLastName}`,
                  purpose: directMatch.purpose || "Mission",
                  status: "Processus de sortie uniquement",
                });
              } else if (hasInitialState && hasFinalState) {
                console.log("C'est un processus complet (entrée et sortie)");
                setCurrentPair({
                  id: directMatch._id,
                  entryProcess: directMatch, // Utiliser la même affectation pour les deux
                  exitProcess: directMatch, // Car elle contient à la fois initialState et finalState
                  date: directMatch.date,
                  driverName: `${directMatch.driverFirstName} ${directMatch.driverLastName}`,
                  purpose: directMatch.purpose || "Mission",
                  status: "Processus complet",
                });
              } else {
                console.warn(
                  "Impossible de déterminer le type de processus - pas d'état"
                );
                setError(
                  "Processus non trouvé pour ce véhicule (pas d'état d'inspection)."
                );
              }
            } else {
              setError("Processus non trouvé pour ce véhicule.");
            }
          }
        }
      } catch (err) {
        console.error("Erreur lors de la récupération de l'historique:", err);
        setError("Impossible de charger l'historique du véhicule.");
      } finally {
        setLoading(false);
      }
    };

    fetchVehicleHistory();
  }, [plate, processId, isProcessDetail]);

  // Charger les réparations du véhicule
  useEffect(() => {
    const fetchRepairs = async () => {
      if (!plate) return;
      setLoadingRepairs(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_URL}/repairs/vehicle/${plate}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data?.success) {
          setRepairs(response.data.repairs || []);
        }
      } catch (err) {
        console.error("Erreur lors de la récupération des réparations:", err);
      } finally {
        setLoadingRepairs(false);
      }
    };
    fetchRepairs();
  }, [plate]);

  // Nouvel useEffect pour charger l'historique des dégâts lorsqu'on a un processus actif
  useEffect(() => {
    const fetchHistoricalDamages = async () => {
      if (!currentPair) return;

      const assignmentId = currentPair.id;
      setLoadingHistoricalDamages(true);

      try {
        const historicalDamagesData =
          await VehicleService.getAssignmentWithHistoricalDamages(assignmentId);
        console.log(
          "=== DONNÉES HISTORIQUES DES DÉGÂTS ===",
          historicalDamagesData
        );
        setHistoricalDamages(historicalDamagesData);
      } catch (err) {
        console.error(
          "Erreur lors de la récupération de l'historique des dégâts:",
          err
        );
        // On ne définit pas d'erreur globale pour ne pas perturber l'affichage principal
      } finally {
        setLoadingHistoricalDamages(false);
      }
    };

    if (currentPair && isProcessDetail) {
      fetchHistoricalDamages();
    }
  }, [currentPair, isProcessDetail]);

  // Gérer les changements de filtres de dégâts
  const handleDamageFilterChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setDamageFilters({
      ...damageFilters,
      [event.target.name]: event.target.checked,
    });
  };

  // Filtrage et tri des processus
  const filteredAndSortedProcessPairs = processPairs
    .filter((pair) => {
      // Filtre par recherche
      if (processSearch) {
        const search = processSearch.toLowerCase();
        const matchDriver = pair.driverName?.toLowerCase().includes(search);
        const matchPurpose = pair.purpose?.toLowerCase().includes(search);
        const matchDate = pair.date?.toLowerCase().includes(search);
        const matchCreator = (pair.entryProcess as any)?.createdByName?.toLowerCase().includes(search);
        if (!matchDriver && !matchPurpose && !matchDate && !matchCreator) {
          return false;
        }
      }
      // Filtre par statut
      if (processStatusFilter !== "all") {
        if (processStatusFilter === "completed" && pair.status !== "Complété") return false;
        if (processStatusFilter === "in_progress" && pair.status === "Complété") return false;
      }
      return true;
    })
    .sort((a, b) => {
      switch (processSort) {
        case "date_asc":
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        case "date_desc":
          return new Date(b.date).getTime() - new Date(a.date).getTime();
        case "driver":
          return a.driverName.localeCompare(b.driverName);
        case "status":
          return a.status.localeCompare(b.status);
        default:
          return 0;
      }
    });

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  // Pour le rendu des types de dégâts
  const getDamageLabel = (type: string): string => {
    switch (type.toLowerCase()) {
      case "rayure":
        return "Rayure";
      case "choc":
        return "Choc";
      case "manquant":
        return "Élément manquant";
      case "casse":
        return "Élément cassé";
      default:
        return type;
    }
  };

  // Pour le rendu des faces
  const getFaceLabel = (face: string): string => {
    switch (face) {
      case "avant":
        return "Avant";
      case "arriere":
        return "Arrière";
      case "coteConducteur":
        return "Côté conducteur";
      case "cotePassager":
        return "Côté passager";
      case "toit":
        return "Toit";
      case "gauche":
        return "Gauche";
      case "droite":
        return "Droite";
      default:
        return face;
    }
  };

  // Nouveau: mappage des noms de faces vers les chemins d'images (utilise les photos du véhicule si disponibles)
  const getFaceImagePath = (face: string): string => {
    // D'abord essayer d'utiliser les photos d'inspection du véhicule
    const inspectionPhotos = history?.inspectionPhotos;
    if (inspectionPhotos) {
      const photoMap: Record<string, string | undefined> = {
        avant: inspectionPhotos.front,
        arriere: inspectionPhotos.back,
        coteConducteur: inspectionPhotos.driverSide,
        cotePassager: inspectionPhotos.passengerSide,
        gauche: inspectionPhotos.driverSide,
        droite: inspectionPhotos.passengerSide,
        interieur: inspectionPhotos.interior,
        moteur: inspectionPhotos.engine,
      };
      if (photoMap[face]) {
        return photoMap[face]!;
      }
    }
    
    // Sinon utiliser les images par défaut
    const imagePathMap: Record<string, string> = {
      avant: "face.png",
      arriere: "derriere.png",
      coteConducteur: "gauche.png",
      cotePassager: "droite.png",
      toit: "toit.png",
      gauche: "gauche.png",
      droite: "droite.png",
      interieur: "interieur.png",
      moteur: "moteur.png",
    };

    return `/images/vehicles/${imagePathMap[face] || "default.png"}`;
  };

  // Pour générer une couleur selon la catégorie et le type de dégât
  const getDamageColor = (type: string, category?: string): string => {
    // Si une catégorie est spécifiée, on l'utilise d'abord
    if (category) {
      switch (category) {
        case "previous":
          return "#FF9800"; // Orange pour les dégâts préexistants
        case "initial":
          return "#2196F3"; // Bleu pour les dégâts initiaux
        case "new":
          return "#F44336"; // Rouge pour les nouveaux dégâts
      }
    }

    // Sinon on utilise le type (comportement actuel)
    switch (type.toLowerCase()) {
      case "rayure":
        return "#FF9800"; // Orange vif
      case "choc":
        return "#F44336"; // Rouge vif
      case "manquant":
        return "#9C27B0"; // Violet vif
      case "casse":
        return "#2196F3"; // Bleu vif
      default:
        return "#757575"; // Gris
    }
  };

  // Nouvelle fonction pour obtenir l'icône selon le type de dégât
  const getDamageIcon = (type: string) => {
    switch (type.toLowerCase()) {
      case "rayure":
        return <ScratchIcon fontSize="small" />;
      case "choc":
        return <ImpactIcon fontSize="small" />;
      case "manquant":
        return <MissingIcon fontSize="small" />;
      case "casse":
        return <BrokenIcon fontSize="small" />;
      default:
        return <DotIcon fontSize="small" />;
    }
  };

  // Formater la date
  const formatDate = (dateString: string): string => {
    return dayjs(dateString).format("DD/MM/YYYY");
  };

  // Fonction pour déterminer si deux dégâts sont empilés/superposés
  const areDamagesStacked = (
    damage1: Damage,
    damage2: Damage,
    threshold = 5
  ) => {
    if (!damage1.position || !damage2.position) return false;

    const distance = Math.sqrt(
      Math.pow(damage1.position.x - damage2.position.x, 2) +
        Math.pow(damage1.position.y - damage2.position.y, 2)
    );

    return distance < threshold; // Si la distance est inférieure au seuil (en %), on considère qu'ils sont empilés
  };

  // Grouper les dégâts qui sont empilés
  const groupDamages = (damages: any[]) => {
    if (!damages || damages.length === 0) return [];

    const groups: any[][] = [];
    const processed = new Set<number>();

    damages.forEach((damage, index) => {
      if (processed.has(index)) return;

      const group = [damage];
      processed.add(index);

      damages.forEach((otherDamage, otherIndex) => {
        if (
          index !== otherIndex &&
          !processed.has(otherIndex) &&
          areDamagesStacked(damage, otherDamage)
        ) {
          group.push(otherDamage);
          processed.add(otherIndex);
        }
      });

      groups.push(group);
    });

    return groups;
  };

  // Ouvrir le dialogue pour afficher les dégâts regroupés
  const handleOpenDamageDialog = (
    damages: any[],
    face: string,
    event: React.MouseEvent
  ) => {
    // Empêcher la propagation de l'événement
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    console.log(
      "Ouverture du dialogue avec",
      damages.length,
      "dégâts sur la face",
      face
    );
    setSelectedDamages(damages);
    setDialogTitle(
      `Dégâts sur ${getFaceLabel(String(face))} (${damages.length})`
    );

    // Force le rendu du Dialog
    setTimeout(() => {
      setDamageDialogOpen(true);
    }, 0);
  };

  // Fermer le dialogue
  const handleCloseDamageDialog = (event?: React.MouseEvent) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    console.log("Fermeture du dialogue");
    setDamageDialogOpen(false);
    setSelectedDamages([]);
  };

  // Rendu du détail d'un processus
  const renderProcessDetails = (assignment: any, isEntry: boolean) => {
    if (!assignment) {
      console.warn(
        `Aucun processus ${isEntry ? "d'entrée" : "de sortie"} trouvé.`
      );
      return (
        <Typography color="text.secondary" align="center">
          Aucun processus {isEntry ? "d'entrée" : "de sortie"} trouvé.
        </Typography>
      );
    }

    // Log pour déboguer l'objet assignment
    console.log(
      `=== DÉTAILS DU PROCESSUS ${isEntry ? "ENTRÉE" : "SORTIE"} ===`,
      assignment
    );
    console.log("_id:", assignment._id);
    console.log("initialState:", assignment.initialState);
    console.log("finalState:", assignment.finalState);
    console.log("signatures:", assignment.signatures);
    console.log("returnSignatures:", assignment.returnSignatures);
    console.log("damages:", assignment.damages);

    // IMPORTANT: Utiliser l'état d'inspection approprié selon le type de processus
    const inspectionState = isEntry
      ? assignment.initialState
      : assignment.finalState;
    console.log("inspectionState utilisé:", inspectionState);

    // Récupérer les signatures appropriées en fonction du type de processus
    const processSignatures = isEntry
      ? assignment.signatures
      : assignment.returnSignatures;

    // Récupérer seulement les dégâts correspondant au processus actuel (entrée ou sortie)
    const processDamages = !inspectionState?.degradations?.images
      ? []
      : Array.isArray(inspectionState.degradations.images)
      ? inspectionState.degradations.images
      : [];

    // Vérifier si l'état d'inspection existe
    if (isEntry && !assignment.initialState) {
      console.warn(
        "⚠️ ATTENTION: initialState n'existe pas pour ce processus d'entrée"
      );
    }
    if (!isEntry && !assignment.finalState) {
      console.warn(
        "⚠️ ATTENTION: finalState n'existe pas pour ce processus de sortie"
      );
    }

    return (
      <CardContent>
        {/* Informations générales du processus */}
        <Typography
          variant="h6"
          gutterBottom
          sx={{ mb: 3, borderBottom: "1px solid #eee", pb: 1 }}
        >
          Informations générales
        </Typography>

        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid sx={{ gridColumn: { xs: "span 12", md: "span 6" } }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>ID:</strong> {assignment._id}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Date:</strong>{" "}
              {dayjs(assignment.date).format("DD/MM/YYYY")}{" "}
              {assignment.time && `à ${assignment.time}`}
            </Typography>
            {assignment.driverFirstName && (
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Conducteur:</strong> {assignment.driverFirstName}{" "}
                {assignment.driverLastName}
              </Typography>
            )}
            {assignment.purpose && (
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Mission:</strong> {assignment.purpose}
              </Typography>
            )}
            {assignment.createdByName && (
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Créé par:</strong> {assignment.createdByName}
              </Typography>
            )}
            {isEntry && assignment.expectedDuration && (
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Durée prévue:</strong> {assignment.expectedDuration}{" "}
                {assignment.expectedDuration > 1 ? "jours" : "jour"}
              </Typography>
            )}
          </Grid>
          <Grid sx={{ gridColumn: { xs: "span 12", md: "span 6" } }}>
            {assignment.status && (
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Statut:</strong> {assignment.status}
              </Typography>
            )}
            {assignment.currentStep && (
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Étape actuelle:</strong> {assignment.currentStep}
              </Typography>
            )}
            {assignment.startMileage !== undefined && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                <SpeedIcon
                  fontSize="small"
                  sx={{ verticalAlign: "middle", mr: 0.5 }}
                />
                <strong>Kilométrage:</strong> {assignment.startMileage}
                {!isEntry && assignment.endMileage
                  ? ` → ${assignment.endMileage} km`
                  : " km"}
              </Typography>
            )}
            {assignment.startFuelLevel && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                <FuelIcon
                  fontSize="small"
                  sx={{ verticalAlign: "middle", mr: 0.5 }}
                />
                <strong>Niveau carburant:</strong> {assignment.startFuelLevel}%
                {!isEntry && assignment.endFuelLevel
                  ? ` → ${assignment.endFuelLevel}%`
                  : ""}
              </Typography>
            )}
            {isEntry && assignment.destination && (
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Destination:</strong> {assignment.destination}
              </Typography>
            )}
          </Grid>
        </Grid>


        {/* Affichage des données brutes (pour débogage) */}
        {false && (
          <Box
            sx={{
              mb: 3,
              p: 2,
              bgcolor: "#f5f5f5",
              borderRadius: 1,
              fontSize: "0.75rem",
              overflow: "auto",
              maxHeight: 200,
            }}
          >
            <Typography variant="subtitle2" gutterBottom>
              Données brutes (pour débogage) :
            </Typography>
            <pre>{JSON.stringify(assignment, null, 2)}</pre>
          </Box>
        )}

        {/* Détails spécifiques au processus d'entrée */}
        {isEntry && (
          <Box sx={{ mt: 3, mb: 3 }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ mb: 3, borderBottom: "1px solid #eee", pb: 1 }}
            >
              Détails du processus d'entrée
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                {assignment.requestedBy && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Demandé par:</strong> {assignment.requestedBy}
                  </Typography>
                )}
                {assignment.authorizedBy && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Autorisé par:</strong> {assignment.authorizedBy}
                  </Typography>
                )}
                {assignment.department && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Département:</strong> {assignment.department}
                  </Typography>
                )}
                {assignment.projectCode && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Code projet:</strong> {assignment.projectCode}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {/* Nouvel affichage équipement de manutention */}
                {assignment.equipment?.taken && (
                  <Box sx={{ 
                    mb: 2, 
                    p: 2, 
                    bgcolor: assignment.equipment.returned ? '#F0FDF4' : '#FEF3C7', 
                    borderRadius: 2,
                    border: assignment.equipment.returned ? '2px solid #86EFAC' : '2px solid #FCD34D'
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1.5 }}>
                      <Box sx={{ 
                        width: 48, 
                        height: 48, 
                        bgcolor: 'white', 
                        borderRadius: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                      }}>
                        <img 
                          src={`/equipements/${assignment.equipment.equipmentType?.replace(/_/g, '-') || 'diable'}.png`}
                          alt=""
                          style={{ width: 32, height: 32, objectFit: 'contain' }}
                          onError={(e) => { (e.target as HTMLImageElement).src = '/equipements/diable.png'; }}
                        />
                      </Box>
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="subtitle2" fontWeight={700} color={assignment.equipment.returned ? '#166534' : '#92400E'}>
                          {assignment.equipment.equipmentBrand} {assignment.equipment.equipmentModel}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          N° {assignment.equipment.equipmentNumber} • {assignment.equipment.equipmentType?.replace(/_/g, ' ')}
                        </Typography>
                      </Box>
                      <Chip 
                        size="small"
                        label={assignment.equipment.returned ? "✓ Rendu" : "En cours"}
                        color={assignment.equipment.returned ? "success" : "warning"}
                        sx={{ fontWeight: 600 }}
                      />
                    </Box>
                    {assignment.equipment.returnCondition && assignment.equipment.returnCondition !== "bon_etat" && (
                      <Box sx={{ 
                        mt: 1.5, 
                        p: 1.5, 
                        bgcolor: assignment.equipment.returnCondition === "endommagé" ? '#FEF2F2' : '#FEE2E2',
                        borderRadius: 1,
                        border: '1px solid #FECACA'
                      }}>
                        <Typography variant="body2" fontWeight={600} color="error.dark">
                          {assignment.equipment.returnCondition === "endommagé" ? "⚠️ Retourné endommagé" : "❌ Non retourné"}
                        </Typography>
                        {assignment.equipment.returnComment && (
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                            {assignment.equipment.returnComment}
                          </Typography>
                        )}
                      </Box>
                    )}
                  </Box>
                )}
                {/* Ancien format - pour rétrocompatibilité */}
                {assignment.equipmentTaken &&
                  assignment.equipmentTaken.length > 0 && (
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="body2" sx={{ mb: 0.5 }}>
                        <strong>Équipement emporté:</strong>
                      </Typography>
                      <List dense disablePadding sx={{ pl: 2 }}>
                        {assignment.equipmentTaken.map(
                          (item: string, idx: number) => (
                            <ListItem key={idx} disablePadding>
                              <ListItemText primary={item} />
                            </ListItem>
                          )
                        )}
                      </List>
                    </Box>
                  )}
                {assignment.passengers !== undefined &&
                  assignment.passengers > 0 && (
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Passagers:</strong> {assignment.passengers}
                    </Typography>
                  )}
              </Grid>
            </Grid>

            {/* Si aucune information spécifique n'est disponible */}
            {!assignment.requestedBy &&
              !assignment.authorizedBy &&
              !assignment.department &&
              !assignment.projectCode &&
              !assignment.equipment?.taken &&
              (!assignment.equipmentTaken ||
                assignment.equipmentTaken.length === 0) &&
              (assignment.passengers === undefined ||
                assignment.passengers <= 0) && (
                <Typography color="text.secondary" align="center">
                  Aucune information supplémentaire disponible pour ce processus
                  d'entrée.
                </Typography>
              )}
          </Box>
        )}

        {/* Détails spécifiques au processus de sortie */}
        {!isEntry && (
          <Box sx={{ mt: 3, mb: 3 }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ mb: 3, borderBottom: "solid 1px #eee", pb: 1 }}
            >
              Détails du processus de sortie
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                {assignment.distanceTraveled && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Distance parcourue:</strong>{" "}
                    {assignment.distanceTraveled} km
                  </Typography>
                )}
                {assignment.duration && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Durée réelle:</strong> {assignment.duration}{" "}
                    {assignment.duration > 1 ? "jours" : "jour"}
                  </Typography>
                )}
                {assignment.returnDate && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Date de retour:</strong>{" "}
                    {dayjs(assignment.returnDate).format("DD/MM/YYYY")}{" "}
                    {assignment.endTime && `à ${assignment.endTime}`}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {assignment.fuelAdded && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Carburant ajouté:</strong> {assignment.fuelAdded} L
                  </Typography>
                )}
                {assignment.returnedBy && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Retourné par:</strong> {assignment.returnedBy}
                  </Typography>
                )}
                {assignment.receivedBy && (
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Reçu par:</strong> {assignment.receivedBy}
                  </Typography>
                )}
              </Grid>
            </Grid>

            {/* Si aucune information spécifique n'est disponible */}
            {false &&
              !assignment.distanceTraveled &&
              !assignment.duration &&
              !assignment.returnDate &&
              !assignment.fuelAdded &&
              !assignment.returnedBy &&
              !assignment.receivedBy && (
                <Typography color="text.secondary" align="center">
                  Aucune information supplémentaire disponible pour ce processus
                  de sortie.
                </Typography>
              )}
          </Box>
        )}

        {/* Documents */}
        {assignment.documents && assignment.documents.length > 0 && (
          <Box sx={{ mt: 3, mb: 3 }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ mb: 3, borderBottom: "solid 1px #eee", pb: 1 }}
            >
              Documents
            </Typography>

            <List dense>
              {assignment.documents.map((doc: any, idx: number) => (
                <ListItem key={idx}>
                  <ListItemText
                    primary={doc.name || `Document ${idx + 1}`}
                    secondary={doc.type || "Type non spécifié"}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        )}

        {/* États d'inspection - vérification que les données d'inspection existent */}
        {inspectionState && (
          <>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ mb: 3, borderBottom: "solid 1px #eee", pb: 1 }}
            >
              Inspection {isEntry ? "initiale" : "finale"}
            </Typography>

            {/* Vérifier que les données de propreté, checklist et dégradations existent */}
            {inspectionState.cleanliness &&
            inspectionState.checklist &&
            inspectionState.degradations ? (
              <InspectionCarousel inspectionState={inspectionState} />
            ) : (
              <Typography color="text.secondary" align="center">
                Données d'inspection incomplètes pour ce processus.
              </Typography>
            )}

            {/* Observations d'inspection supplémentaires */}
            {inspectionState.observations && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Observations supplémentaires:
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  {inspectionState.observations}
                </Typography>
              </Box>
            )}
          </>
        )}

        {/* Commentaires & Notes */}
        {(assignment.comments ||
          (inspectionState && inspectionState.comments)) && (
          <Box sx={{ mt: 3 }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ mb: 2, borderBottom: "solid 1px #eee", pb: 1 }}
            >
              Commentaires et notes
            </Typography>

            {assignment.comments && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2" gutterBottom>
                  Notes générales:
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  {assignment.comments}
                </Typography>
              </Box>
            )}

            {inspectionState && inspectionState.comments && (
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  Notes d'inspection:
                </Typography>
                <Typography variant="body2" sx={{ pl: 2 }}>
                  {inspectionState.comments}
                </Typography>
              </Box>
            )}
          </Box>
        )}

        {/* Afficher les dégâts avec des types valides */}
        {processDamages && processDamages.length > 0 && (
          <Box sx={{ mt: 3 }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                mb: 2,
                borderBottom: "solid 1px #eee",
                pb: 1,
                color: isEntry ? "primary.main" : "error.main",
                fontWeight: "bold",
              }}
            >
              Dégradations signalées {isEntry ? "à l'entrée" : "au retour"}
            </Typography>

            {/* Filtres pour les catégories de dégâts - uniquement si on a des données historiques */}
            {historicalDamages && (
              <Box
                sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}
              >
                <FilterIcon color="action" />
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={damageFilters.showPreexisting}
                        onChange={handleDamageFilterChange}
                        name="showPreexisting"
                        color="warning"
                        size="small"
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        sx={{ color: getDamageColor("", "previous") }}
                      >
                        Dégâts préexistants
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={damageFilters.showInitial}
                        onChange={handleDamageFilterChange}
                        name="showInitial"
                        color="primary"
                        size="small"
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        sx={{ color: getDamageColor("", "initial") }}
                      >
                        Dégâts initiaux
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={damageFilters.showNew}
                        onChange={handleDamageFilterChange}
                        name="showNew"
                        color="error"
                        size="small"
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        sx={{ color: getDamageColor("", "new") }}
                      >
                        Nouveaux dégâts
                      </Typography>
                    }
                  />
                </FormGroup>
              </Box>
            )}

            {/* Visualisation des dégâts sur les images des faces */}
            {Array.from(
              new Set(
                processDamages
                  .filter((d: any) => d.damageType && d.face)
                  .map((d: any) => d.face)
              )
            ).map((face) => (
              <Box key={String(face)} sx={{ mb: 3, mt: 2 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ mb: 1, fontWeight: "bold" }}
                >
                  Face: {face ? getFaceLabel(String(face)) : "Non spécifiée"}
                </Typography>

                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    maxWidth: 600,
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    overflow: "hidden",
                    mx: "auto",
                    mb: 2,
                    backgroundColor: "#f5f5f5",
                  }}
                >
                  {/* Image de fond pour la face - aspect ratio naturel */}
                  <Box
                    component="img"
                    src={
                      historicalDamages?.faceImages?.[String(face)] ||
                      getFaceImagePath(String(face))
                    }
                    alt={`Face ${getFaceLabel(String(face))}`}
                    onError={(e) => {
                      // Utiliser une image par défaut si l'image n'est pas trouvée
                      const target = e.target as HTMLImageElement;
                      target.onerror = null;
                      target.src = "/images/vehicles/default.png";
                    }}
                    sx={{
                      width: "100%",
                      height: "auto",
                      display: "block",
                    }}
                  />

                  {/* Afficher les dégâts préexistants si disponibles et filtrés */}
                  {historicalDamages?.historicalDamages.previous[
                    String(face)
                  ] &&
                    damageFilters.showPreexisting &&
                    groupDamages(
                      historicalDamages.historicalDamages.previous[
                        String(face)
                      ].filter((d) => d.position)
                    ).map((damageGroup, groupIdx) => (
                      <Tooltip
                        key={`prev-${groupIdx}`}
                        title={
                          damageGroup.length > 1
                            ? `Groupe de ${damageGroup.length} dégâts préexistants (cliquer pour détails)`
                            : `Dégât préexistant: ${getDamageLabel(
                                damageGroup[0].damageType
                              )} - ${damageGroup[0].driverId || "N/A"}`
                        }
                      >
                        <Box
                          onClick={(e) => {
                            handleOpenDamageDialog(
                              damageGroup,
                              String(face),
                              e
                            );
                          }}
                          sx={{
                            position: "absolute",
                            left: `${damageGroup[0].position.x}%`,
                            top: `${damageGroup[0].position.y}%`,
                            width: damageGroup.length > 1 ? 32 : 24,
                            height: damageGroup.length > 1 ? 32 : 24,
                            borderRadius: "50%",
                            backgroundColor:
                              damageGroup.length > 1
                                ? `rgba(255, 152, 0, 0.7)`
                                : `${getDamageColor(
                                    damageGroup[0].damageType,
                                    "previous"
                                  )}90`,
                            border:
                              damageGroup.length > 1
                                ? `2px solid #FF9800`
                                : `2px solid ${getDamageColor(
                                    damageGroup[0].damageType,
                                    "previous"
                                  )}`,
                            transform: "translate(-50%, -50%)",
                            cursor: "pointer",
                            zIndex: 10,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#fff",
                            boxShadow: "0 0 5px rgba(0,0,0,0.3)",
                            "&:hover": {
                              boxShadow: "0 0 10px rgba(0,0,0,0.6)",
                              transform: "translate(-50%, -50%) scale(1.1)",
                              transition: "transform 0.2s ease",
                            },
                          }}
                        >
                          {damageGroup.length > 1 ? (
                            <>
                              <Typography
                                variant="caption"
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: "0.7rem",
                                }}
                              >
                                {damageGroup.length}
                              </Typography>
                            </>
                          ) : (
                            <>
                              {getDamageIcon(damageGroup[0].damageType)}
                              <Typography
                                variant="caption"
                                sx={{
                                  fontSize: "0.6rem",
                                  fontWeight: "bold",
                                  position: "absolute",
                                  bottom: "-20px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  backgroundColor: "rgba(255,255,255,0.8)",
                                  padding: "1px 4px",
                                  borderRadius: "3px",
                                  border: `1px solid ${getDamageColor(
                                    damageGroup[0].damageType,
                                    "previous"
                                  )}`,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {damageGroup[0].driverId
                                  ? damageGroup[0].driverId
                                  : "N/A"}
                              </Typography>
                            </>
                          )}
                        </Box>
                      </Tooltip>
                    ))}

                  {/* Afficher les dégâts initiaux si disponibles et filtrés */}
                  {historicalDamages?.historicalDamages.initial[String(face)] &&
                    damageFilters.showInitial &&
                    groupDamages(
                      historicalDamages.historicalDamages.initial[
                        String(face)
                      ].filter((d) => d.position)
                    ).map((damageGroup, groupIdx) => (
                      <Tooltip
                        key={`init-${groupIdx}`}
                        title={
                          damageGroup.length > 1
                            ? `Groupe de ${damageGroup.length} dégâts initiaux (cliquer pour détails)`
                            : `Dégât initial: ${getDamageLabel(
                                damageGroup[0].damageType
                              )} - ${damageGroup[0].driverId || "N/A"}`
                        }
                      >
                        <Box
                          onClick={(e) => {
                            handleOpenDamageDialog(
                              damageGroup,
                              String(face),
                              e
                            );
                          }}
                          sx={{
                            position: "absolute",
                            left: `${damageGroup[0].position.x}%`,
                            top: `${damageGroup[0].position.y}%`,
                            width: damageGroup.length > 1 ? 32 : 24,
                            height: damageGroup.length > 1 ? 32 : 24,
                            borderRadius: "50%",
                            backgroundColor:
                              damageGroup.length > 1
                                ? `rgba(33, 150, 243, 0.7)`
                                : `${getDamageColor(
                                    damageGroup[0].damageType,
                                    "initial"
                                  )}90`,
                            border:
                              damageGroup.length > 1
                                ? `2px solid #2196F3`
                                : `2px solid ${getDamageColor(
                                    damageGroup[0].damageType,
                                    "initial"
                                  )}`,
                            transform: "translate(-50%, -50%)",
                            cursor: "pointer",
                            zIndex: 11, // Plus élevé que les dégâts préexistants
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#fff",
                            boxShadow: "0 0 5px rgba(0,0,0,0.3)",
                            "&:hover": {
                              boxShadow: "0 0 10px rgba(0,0,0,0.6)",
                              transform: "translate(-50%, -50%) scale(1.1)",
                              transition: "transform 0.2s ease",
                            },
                          }}
                        >
                          {damageGroup.length > 1 ? (
                            <>
                              <Typography
                                variant="caption"
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: "0.7rem",
                                }}
                              >
                                {damageGroup.length}
                              </Typography>
                            </>
                          ) : (
                            <>
                              {getDamageIcon(damageGroup[0].damageType)}
                              <Typography
                                variant="caption"
                                sx={{
                                  fontSize: "0.6rem",
                                  fontWeight: "bold",
                                  position: "absolute",
                                  bottom: "-20px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  backgroundColor: "rgba(255,255,255,0.8)",
                                  padding: "1px 4px",
                                  borderRadius: "3px",
                                  border: `1px solid ${getDamageColor(
                                    damageGroup[0].damageType,
                                    "initial"
                                  )}`,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {damageGroup[0].driverId
                                  ? damageGroup[0].driverId
                                  : "N/A"}
                              </Typography>
                            </>
                          )}
                        </Box>
                      </Tooltip>
                    ))}

                  {/* Afficher les nouveaux dégâts si disponibles et filtrés */}
                  {!isEntry &&
                    historicalDamages?.historicalDamages.new[String(face)] &&
                    damageFilters.showNew &&
                    groupDamages(
                      historicalDamages.historicalDamages.new[
                        String(face)
                      ].filter((d) => d.position)
                    ).map((damageGroup, groupIdx) => (
                      <Tooltip
                        key={`new-${groupIdx}`}
                        title={
                          damageGroup.length > 1
                            ? `Groupe de ${damageGroup.length} nouveaux dégâts (cliquer pour détails)`
                            : `Nouveau dégât: ${getDamageLabel(
                                damageGroup[0].damageType
                              )} - ${damageGroup[0].driverId || "N/A"}`
                        }
                      >
                        <Box
                          onClick={(e) => {
                            handleOpenDamageDialog(
                              damageGroup,
                              String(face),
                              e
                            );
                          }}
                          sx={{
                            position: "absolute",
                            left: `${damageGroup[0].position.x}%`,
                            top: `${damageGroup[0].position.y}%`,
                            width: damageGroup.length > 1 ? 32 : 24,
                            height: damageGroup.length > 1 ? 32 : 24,
                            borderRadius: "50%",
                            backgroundColor:
                              damageGroup.length > 1
                                ? `rgba(244, 67, 54, 0.7)`
                                : `${getDamageColor(
                                    damageGroup[0].damageType,
                                    "new"
                                  )}90`,
                            border:
                              damageGroup.length > 1
                                ? `2px solid #F44336`
                                : `2px solid ${getDamageColor(
                                    damageGroup[0].damageType,
                                    "new"
                                  )}`,
                            transform: "translate(-50%, -50%)",
                            cursor: "pointer",
                            zIndex: 12, // Plus élevé que les dégâts initiaux
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#fff",
                            boxShadow: "0 0 8px rgba(211, 47, 47, 0.5)",
                            "&:hover": {
                              boxShadow: "0 0 10px rgba(0,0,0,0.6)",
                              transform: "translate(-50%, -50%) scale(1.1)",
                              transition: "transform 0.2s ease",
                            },
                          }}
                        >
                          {damageGroup.length > 1 ? (
                            <>
                              <Typography
                                variant="caption"
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: "0.7rem",
                                }}
                              >
                                {damageGroup.length}
                              </Typography>
                            </>
                          ) : (
                            <>
                              {getDamageIcon(damageGroup[0].damageType)}
                              <Typography
                                variant="caption"
                                sx={{
                                  fontSize: "0.6rem",
                                  fontWeight: "bold",
                                  position: "absolute",
                                  bottom: "-20px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  backgroundColor: "rgba(255,255,255,0.8)",
                                  padding: "1px 4px",
                                  borderRadius: "3px",
                                  border: `1px solid ${getDamageColor(
                                    damageGroup[0].damageType,
                                    "new"
                                  )}`,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {damageGroup[0].driverId
                                  ? damageGroup[0].driverId
                                  : "N/A"}
                              </Typography>
                            </>
                          )}
                        </Box>
                      </Tooltip>
                    ))}

                  {/* Garder l'affichage des dégâts actuels pour la compatibilité (si historicalDamages n'est pas disponible) */}
                  {(!historicalDamages || loadingHistoricalDamages) &&
                    groupDamages(
                      processDamages.filter(
                        (d) => d.damageType && d.face === face && d.position
                      )
                    ).map((damageGroup, groupIdx) => (
                      <Tooltip
                        key={groupIdx}
                        title={
                          damageGroup.length > 1
                            ? `Groupe de ${damageGroup.length} dégâts (cliquer pour détails)`
                            : `${getDamageLabel(damageGroup[0].damageType)} - ${
                                damageGroup[0].driverId || "N/A"
                              }`
                        }
                      >
                        <Box
                          onClick={(e) => {
                            console.log("Clic sur marqueur de dégât");
                            handleOpenDamageDialog(
                              damageGroup,
                              String(face),
                              e
                            );
                          }}
                          sx={{
                            position: "absolute",
                            left: `${damageGroup[0].position.x}%`,
                            top: `${damageGroup[0].position.y}%`,
                            width: damageGroup.length > 1 ? 32 : 24,
                            height: damageGroup.length > 1 ? 32 : 24,
                            borderRadius: "50%",
                            backgroundColor:
                              damageGroup.length > 1
                                ? `rgba(25, 118, 210, 0.7)`
                                : `${getDamageColor(
                                    damageGroup[0].damageType
                                  )}90`,
                            border:
                              damageGroup.length > 1
                                ? `2px solid #1976d2`
                                : `2px solid ${getDamageColor(
                                    damageGroup[0].damageType
                                  )}`,
                            transform: "translate(-50%, -50%)",
                            cursor: "pointer",
                            zIndex: 10,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#fff",
                            boxShadow: !isEntry
                              ? "0 0 8px rgba(211, 47, 47, 0.5)"
                              : "0 0 5px rgba(0,0,0,0.3)",
                            "&:hover": {
                              boxShadow: "0 0 10px rgba(0,0,0,0.6)",
                              transform: "translate(-50%, -50%) scale(1.1)",
                              transition: "transform 0.2s ease",
                            },
                          }}
                        >
                          {damageGroup.length > 1 ? (
                            <>
                              <Typography
                                variant="caption"
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: "0.7rem",
                                }}
                              >
                                {damageGroup.length}
                              </Typography>
                            </>
                          ) : (
                            <>
                              {getDamageIcon(damageGroup[0].damageType)}
                              <Typography
                                variant="caption"
                                sx={{
                                  fontSize: "0.6rem",
                                  fontWeight: "bold",
                                  position: "absolute",
                                  bottom: "-20px",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  backgroundColor: "rgba(255,255,255,0.8)",
                                  padding: "1px 4px",
                                  borderRadius: "3px",
                                  border: `1px solid ${getDamageColor(
                                    damageGroup[0].damageType
                                  )}`,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {damageGroup[0].driverId
                                  ? damageGroup[0].driverId
                                  : "N/A"}
                              </Typography>
                            </>
                          )}
                        </Box>
                      </Tooltip>
                    ))}
                </Box>

                {/* Légende des catégories de dégâts */}
                {historicalDamages && (
                  <Box
                    sx={{
                      mb: 2,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1,
                      justifyContent: "center",
                    }}
                  >
                    {damageFilters.showPreexisting && (
                      <Chip
                        size="small"
                        label="Dégâts préexistants"
                        sx={{
                          bgcolor: getDamageColor("", "previous") + "20",
                          color: getDamageColor("", "previous"),
                          borderColor: getDamageColor("", "previous"),
                          borderWidth: 1,
                          borderStyle: "solid",
                        }}
                      />
                    )}
                    {damageFilters.showInitial && (
                      <Chip
                        size="small"
                        label="Dégâts initiaux"
                        sx={{
                          bgcolor: getDamageColor("", "initial") + "20",
                          color: getDamageColor("", "initial"),
                          borderColor: getDamageColor("", "initial"),
                          borderWidth: 1,
                          borderStyle: "solid",
                        }}
                      />
                    )}
                    {damageFilters.showNew && (
                      <Chip
                        size="small"
                        label="Nouveaux dégâts"
                        sx={{
                          bgcolor: getDamageColor("", "new") + "20",
                          color: getDamageColor("", "new"),
                          borderColor: getDamageColor("", "new"),
                          borderWidth: 1,
                          borderStyle: "solid",
                        }}
                      />
                    )}
                  </Box>
                )}

                {/* Liste textuelle des dégâts - garder pour la compatibilité */}
                {processDamages.filter((d) => d.damageType && d.face === face)
                  .length > 0 ? (
                  <Box sx={{ pl: 2 }}>
                    {processDamages
                      .filter((d) => d.damageType && d.face === face)
                      .map((damage, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            mb: 1,
                            display: "flex",
                            alignItems: "flex-start",
                          }}
                        >
                          <Box
                            sx={{
                              width: 24,
                              height: 24,
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: "50%",
                              bgcolor: getDamageColor(damage.damageType) + "20",
                              border: `1px solid ${getDamageColor(
                                damage.damageType
                              )}`,
                              color: getDamageColor(damage.damageType),
                              mt: 0.5,
                              mr: 1,
                              boxShadow: !isEntry
                                ? "0 0 0 2px rgba(211, 47, 47, 0.3)"
                                : "none",
                            }}
                          >
                            {getDamageIcon(damage.damageType)}
                          </Box>
                          <Box>
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: !isEntry ? "bold" : "normal",
                              }}
                            >
                              <strong>
                                {getDamageLabel(damage.damageType)} #{idx + 1}:
                              </strong>
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: "0.9rem",
                                ml: 1,
                                color: "text.secondary",
                              }}
                            >
                              {damage.position && (
                                <span>
                                  Position: x={damage.position.x.toFixed(2)}, y=
                                  {damage.position.y.toFixed(2)}
                                  <br />
                                </span>
                              )}
                              {damage.driverId && (
                                <span>
                                  <strong style={{ color: "#1976d2" }}>
                                    Conducteur: {damage.driverId}
                                  </strong>
                                  <br />
                                </span>
                              )}
                              {damage.date && (
                                <span>
                                  Date:{" "}
                                  {dayjs(damage.date).format("DD/MM/YYYY")}
                                </span>
                              )}
                            </Typography>
                          </Box>
                        </Box>
                      ))}
                  </Box>
                ) : (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    fontStyle="italic"
                    sx={{ p: 2 }}
                  >
                    Aucun dégât constaté {isEntry ? "à l'entrée" : "au retour"}
                  </Typography>
                )}

                {/* Résumé statistique */}
                <Box sx={{ mt: 2, p: 1, bgcolor: "#f9f9f9", borderRadius: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Statistiques:</strong>{" "}
                    {Object.entries({
                      Rayures: processDamages.filter(
                        (d) =>
                          d.damageType &&
                          d.damageType.toLowerCase() === "rayure"
                      ).length,
                      Chocs: processDamages.filter(
                        (d) =>
                          d.damageType && d.damageType.toLowerCase() === "choc"
                      ).length,
                      "Éléments manquants": processDamages.filter(
                        (d) =>
                          d.damageType &&
                          d.damageType.toLowerCase() === "manquant"
                      ).length,
                      "Éléments cassés": processDamages.filter(
                        (d) =>
                          d.damageType && d.damageType.toLowerCase() === "casse"
                      ).length,
                    })
                      .filter(([_, count]) => count > 0)
                      .map(([type, count]) => `${type}: ${count}`)
                      .join(", ")}
                  </Typography>
                </Box>

                {/* Évolution des dégâts - uniquement en mode processus de sortie avec des dégâts à l'entrée et à la sortie */}
                {!isEntry &&
                  currentPair &&
                  currentPair.entryProcess &&
                  currentPair.entryProcess.initialState &&
                  currentPair.entryProcess.initialState.degradations &&
                  currentPair.entryProcess.initialState.degradations.images &&
                  currentPair.entryProcess.initialState.degradations.images
                    .length > 0 &&
                  assignment.finalState &&
                  assignment.finalState.degradations &&
                  assignment.finalState.degradations.images &&
                  assignment.finalState.degradations.images.length > 0 && (
                    <Box
                      sx={{
                        mt: 3,
                        p: 2,
                        bgcolor: "#fffde7",
                        borderRadius: 2,
                        border: "1px solid #fff9c4",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        gutterBottom
                        sx={{ fontWeight: "bold", color: "text.primary" }}
                      >
                        Évolution des dégâts:
                      </Typography>
                      <Typography variant="body2" sx={{ ml: 2 }}>
                        • À l'entrée:{" "}
                        {
                          currentPair.entryProcess.initialState.degradations.images.filter(
                            (d) => d.damageType
                          ).length
                        }{" "}
                        dégât(s) -
                        {currentPair.entryProcess.initialState.degradations.images.filter(
                          (d) => d.damageType
                        ).length > 0
                          ? Array.from(
                              new Set(
                                currentPair.entryProcess.initialState.degradations.images
                                  .filter((d) => d.damageType)
                                  .map((d) => d.damageType)
                              )
                            )
                              .map(
                                (type) =>
                                  `${
                                    currentPair.entryProcess.initialState.degradations.images.filter(
                                      (d) => d.damageType === type
                                    ).length
                                  } ${getDamageLabel(
                                    String(type)
                                  ).toLowerCase()}${
                                    currentPair.entryProcess.initialState.degradations.images.filter(
                                      (d) => d.damageType === type
                                    ).length > 1
                                      ? "s"
                                      : ""
                                  }`
                              )
                              .join(", ")
                          : " aucun"}
                        <br />• Au retour:{" "}
                        {
                          assignment.finalState.degradations.images.filter(
                            (d) => d.damageType
                          ).length
                        }{" "}
                        dégât(s) -
                        {assignment.finalState.degradations.images.filter(
                          (d) => d.damageType
                        ).length > 0
                          ? Array.from(
                              new Set(
                                assignment.finalState.degradations.images
                                  .filter((d) => d.damageType)
                                  .map((d) => d.damageType)
                              )
                            )
                              .map(
                                (type) =>
                                  `${
                                    assignment.finalState.degradations.images.filter(
                                      (d) => d.damageType === type
                                    ).length
                                  } ${getDamageLabel(
                                    String(type)
                                  ).toLowerCase()}${
                                    assignment.finalState.degradations.images.filter(
                                      (d) => d.damageType === type
                                    ).length > 1
                                      ? "s"
                                      : ""
                                  }`
                              )
                              .join(", ")
                          : " aucun"}
                      </Typography>
                    </Box>
                  )}
              </Box>
            ))}

            {/* Affichage des chips de dégâts - garder pour la compatibilité */}
            {processDamages.filter((d) => d.damageType).length > 0 ? (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                {processDamages
                  .filter((d) => d.damageType)
                  .map((damage, idx) => (
                    <Tooltip
                      key={idx}
                      title={`${getDamageLabel(damage.damageType)} - ${
                        damage.face
                          ? getFaceLabel(String(damage.face))
                          : "Face non spécifiée"
                      } 
                              ${
                                damage.position
                                  ? `(x:${damage.position.x.toFixed(
                                      2
                                    )}, y:${damage.position.y.toFixed(2)})`
                                  : ""
                              }`}
                    >
                      <Chip
                        size="small"
                        label={getDamageLabel(damage.damageType)}
                        icon={React.cloneElement(
                          getDamageIcon(damage.damageType),
                          {
                            style: {
                              color: getDamageColor(damage.damageType),
                            },
                          }
                        )}
                        sx={{
                          bgcolor: getDamageColor(damage.damageType) + "20",
                          color: getDamageColor(damage.damageType),
                          borderColor: getDamageColor(damage.damageType),
                          borderWidth: 1,
                          borderStyle: "solid",
                          fontWeight: !isEntry ? "bold" : "normal",
                          boxShadow: !isEntry
                            ? "0 0 0 1px rgba(211, 47, 47, 0.3)"
                            : "none",
                          "& .MuiChip-icon": {
                            color: "inherit",
                          },
                        }}
                      />
                    </Tooltip>
                  ))}
              </Box>
            ) : (
              <Typography
                variant="body2"
                color="text.secondary"
                fontStyle="italic"
                sx={{ p: 2 }}
              >
                Aucun dégât constaté {isEntry ? "à l'entrée" : "au retour"}
              </Typography>
            )}
          </Box>
        )}

        {/* Photos (si disponibles) - garder pour la compatibilité */}
        {assignment.photos && assignment.photos.length > 0 && (
          <Box sx={{ mt: 3 }}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ mb: 2, borderBottom: "solid 1px #eee", pb: 1 }}
            >
              Photos
            </Typography>

            <Typography variant="body2" sx={{ mb: 2 }}>
              {assignment.photos.length} photo(s){" "}
              {isEntry ? "d'entrée" : "de sortie"} disponible(s).
            </Typography>
          </Box>
        )}

        {/* Signatures - Affichage amélioré avec données base64 */}
        <Box sx={{ mt: 3 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              mb: 2,
              borderBottom: "solid 1px #eee",
              pb: 1,
              color: "primary.main",
            }}
          >
            Signatures {isEntry ? "d'entrée" : "de sortie"}
          </Typography>

          <Grid container spacing={2}>
            {/* Signature du conducteur */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  border: "2px solid",
                  borderColor:
                    processSignatures && processSignatures.conducteur
                      ? "success.light"
                      : "grey.300",
                  borderRadius: 2,
                  p: 2,
                  bgcolor:
                    processSignatures && processSignatures.conducteur
                      ? "success.50"
                      : "grey.50",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "bold", color: "text.primary" }}
                >
                  Signature du conducteur
                </Typography>
                <Box
                  sx={{
                    my: 1,
                    p: 2,
                    height: 120,
                    border: "1px dashed",
                    borderColor:
                      processSignatures && processSignatures.conducteur
                        ? "success.main"
                        : "grey.400",
                    borderRadius: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "white",
                  }}
                >
                  {processSignatures &&
                  processSignatures.conducteur &&
                  processSignatures.conducteur.startsWith(
                    "data:image/png;base64,"
                  ) &&
                  processSignatures.conducteur.length > 30 ? (
                    <Box
                      component="img"
                      src={processSignatures.conducteur}
                      alt="Signature du conducteur"
                      sx={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      fontStyle="italic"
                    >
                      {processSignatures && processSignatures.conducteur
                        ? "Format de signature invalide"
                        : "Signature non disponible"}
                    </Typography>
                  )}
                </Box>
                <Box
                  sx={{
                    mt: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="caption" color="text.secondary">
                    {assignment.driverFirstName} {assignment.driverLastName}
                  </Typography>
                  <Chip
                    size="small"
                    label={
                      processSignatures &&
                      processSignatures.conducteur &&
                      processSignatures.conducteur.startsWith(
                        "data:image/png;base64,"
                      ) &&
                      processSignatures.conducteur.length > 30
                        ? "Signé"
                        : "Non signé"
                    }
                    color={
                      processSignatures &&
                      processSignatures.conducteur &&
                      processSignatures.conducteur.startsWith(
                        "data:image/png;base64,"
                      ) &&
                      processSignatures.conducteur.length > 30
                        ? "success"
                        : "default"
                    }
                  />
                </Box>
              </Box>
            </Grid>

            {/* Signature du responsable */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  border: "2px solid",
                  borderColor:
                    processSignatures && processSignatures.manager
                      ? "success.light"
                      : "grey.300",
                  borderRadius: 2,
                  p: 2,
                  bgcolor:
                    processSignatures && processSignatures.manager
                      ? "success.50"
                      : "grey.50",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, fontWeight: "bold", color: "text.primary" }}
                >
                  Signature du responsable
                </Typography>
                <Box
                  sx={{
                    my: 1,
                    p: 2,
                    height: 120,
                    border: "1px dashed",
                    borderColor:
                      processSignatures && processSignatures.manager
                        ? "success.main"
                        : "grey.400",
                    borderRadius: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "white",
                  }}
                >
                  {processSignatures &&
                  processSignatures.manager &&
                  processSignatures.manager.startsWith(
                    "data:image/png;base64,"
                  ) &&
                  processSignatures.manager.length > 30 ? (
                    <Box
                      component="img"
                      src={processSignatures.manager}
                      alt="Signature du responsable"
                      sx={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      fontStyle="italic"
                    >
                      {processSignatures && processSignatures.manager
                        ? "Format de signature invalide"
                        : "Signature non disponible"}
                    </Typography>
                  )}
                </Box>
                <Box
                  sx={{
                    mt: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="caption" color="text.secondary">
                    {assignment.managerName || "Responsable"}
                  </Typography>
                  <Chip
                    size="small"
                    label={
                      processSignatures &&
                      processSignatures.manager &&
                      processSignatures.manager.startsWith(
                        "data:image/png;base64,"
                      ) &&
                      processSignatures.manager.length > 30
                        ? "Signé"
                        : "Non signé"
                    }
                    color={
                      processSignatures &&
                      processSignatures.manager &&
                      processSignatures.manager.startsWith(
                        "data:image/png;base64,"
                      ) &&
                      processSignatures.manager.length > 30
                        ? "success"
                        : "default"
                    }
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Bouton "Voir les détails complets" */}
        {false && (
          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
            <Button
              size="small"
              component={Link}
              to={`/debriefing/${assignment._id}`}
              variant="contained"
              color="primary"
            >
              Voir les détails complets
            </Button>
          </Box>
        )}
      </CardContent>
    );
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (error || !history) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          p: 3,
        }}
      >
        <Typography variant="h5" color="error" gutterBottom>
          {error || "Aucune donnée disponible"}
        </Typography>
        <Button
          onClick={() => navigate(canAccessDashboard ? "/vehicules" : "/historique-vehicules")}
          variant="contained"
          startIcon={<ArrowBackIcon />}
        >
          {canAccessDashboard ? "Retour aux véhicules" : "Retour à l'historique"}
        </Button>
      </Box>
    );
  }

  // Rendu de la page de détails d'un processus
  if (isProcessDetail && currentPair) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          width: "100vw",
          background: "linear-gradient(135deg, #e3f0ff 0%, #f9f9f9 100%)",
          py: { xs: 2, md: 4 },
          px: { xs: 0, md: 0 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 1300,
            mx: "auto",
            boxShadow: 3,
            borderRadius: 4,
            background: "#fff",
            p: { xs: 1.5, sm: 3, md: 4 },
            mt: { xs: 1, md: 3 },
            mb: { xs: 2, md: 4 },
            minHeight: "70vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* En-tête */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 4,
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: 2, sm: 0 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Button
                component={Link}
                to={`/vehicules/historique/${plate}`}
                startIcon={<ArrowBackIcon />}
                variant="outlined"
                color="primary"
                sx={{ borderRadius: 2 }}
              >
                Retour à l'historique
              </Button>
              <Typography
                variant="h5"
                fontWeight={700}
                sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
              >
                <HistoryIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                Détails du processus
              </Typography>
            </Box>
          </Box>

          {/* Informations du processus */}
          <Card
            sx={{
              borderRadius: 2,
              boxShadow: 2,
              mb: 3,
              border: "1px solid",
              borderColor:
                currentPair.status === "Complété"
                  ? "success.light"
                  : "primary.light",
            }}
          >
            <CardHeader
              title={`Affectation: ${currentPair.purpose}`}
              subheader={`${formatDate(currentPair.date)} ${
                currentPair.entryProcess?.time
                  ? `à ${currentPair.entryProcess.time}`
                  : ""
              } - ${currentPair.driverName}`}
              avatar={
                <Avatar>
                  <PersonIcon />
                </Avatar>
              }
              action={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Chip
                    label={currentPair.status}
                    color={
                      currentPair.status === "Complété" ? "success" : "primary"
                    }
                    size="small"
                  />
                </Box>
              }
              onClick={() =>
                navigate(
                  `/vehicules/historique/${plate}/processus/${currentPair.id}`
                )
              }
              sx={{ cursor: "pointer" }}
            />
          </Card>

          {/* Onglets pour les processus - STICKY */}
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 100,
              bgcolor: "white",
              borderBottom: 1,
              borderColor: "divider",
              mb: 3,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              aria-label="process tabs"
              variant="fullWidth"
              sx={{
                "& .MuiTab-root": {
                  fontSize: { xs: "0.85rem", sm: "0.9rem" },
                  fontWeight: 600,
                  py: { xs: 1.5, sm: 2 },
                },
              }}
            >
              <Tab
                icon={<LoginIcon />}
                label="Processus d'Entrée"
                iconPosition="start"
              />
              <Tab
                icon={<LogoutIcon />}
                label="Processus de Sortie"
                iconPosition="start"
              />
            </Tabs>
          </Box>

          {/* Contenu des onglets */}
          <Box sx={{ p: { xs: 1, sm: 1.5 } }}>
            {tabValue === 0
              ? renderProcessDetails(currentPair.entryProcess, true)
              : renderProcessDetails(currentPair.exitProcess, false)}
          </Box>
        </Box>

        {/* Dialog pour afficher les dégâts regroupés - Dupliqué ici pour la vue détaillée */}
        <Dialog
          open={damageDialogOpen}
          onClose={(e) => handleCloseDamageDialog(e as React.MouseEvent)}
          maxWidth="md"
          fullWidth
          keepMounted={false}
          disablePortal={false}
          disableEscapeKeyDown={false}
          disableEnforceFocus={false}
          disableAutoFocus={false}
          disableRestoreFocus={false}
          PaperProps={{
            sx: {
              maxHeight: "80vh",
              minWidth: { xs: "90vw", sm: "70vw", md: "50vw" },
              overflow: "auto",
            },
          }}
          TransitionProps={{
            timeout: 300,
          }}
          sx={{
            zIndex: 1500,
            backdropFilter: "blur(2px)",
          }}
        >
          <DialogTitle
            sx={{
              bgcolor: "primary.main",
              color: "white",
              fontWeight: "bold",
              px: 3,
              py: 2,
            }}
          >
            {dialogTitle}
          </DialogTitle>
          <DialogContent dividers sx={{ p: 3 }}>
            {selectedDamages && selectedDamages.length > 0 ? (
              <List>
                {selectedDamages.map((damage, idx) => (
                  <ListItem
                    key={idx}
                    divider={idx < selectedDamages.length - 1}
                    sx={{
                      py: 2,
                      borderLeft: `4px solid ${getDamageColor(
                        damage.damageType
                      )}`,
                      my: 1,
                      borderRadius: 1,
                      bgcolor: `${getDamageColor(damage.damageType)}10`,
                    }}
                  >
                    <ListItemIcon>
                      <Box
                        sx={{
                          bgcolor: `${getDamageColor(damage.damageType)}30`,
                          p: 1,
                          borderRadius: "50%",
                          color: getDamageColor(damage.damageType),
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {getDamageIcon(damage.damageType)}
                      </Box>
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "bold" }}
                        >
                          {getDamageLabel(damage.damageType)} #{idx + 1}
                        </Typography>
                      }
                      secondary={
                        <>
                          <Typography
                            variant="body2"
                            component="span"
                            display="block"
                            sx={{ mt: 1 }}
                          >
                            Position: x={damage.position?.x.toFixed(2)}, y=
                            {damage.position?.y.toFixed(2)}
                          </Typography>
                          <Box
                            sx={{
                              mt: 1.5,
                              mb: 1,
                              p: 1,
                              bgcolor: "info.light",
                              color: "white",
                              borderRadius: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <PersonIcon sx={{ mr: 1, fontSize: 20 }} />
                            <Typography
                              variant="body1"
                              component="span"
                              sx={{ fontWeight: "bold" }}
                            >
                              ID Conducteur: {damage.driverId || "Non spécifié"}
                            </Typography>
                          </Box>
                          {damage.date && (
                            <Typography
                              variant="body2"
                              component="span"
                              display="block"
                            >
                              Date: {dayjs(damage.date).format("DD/MM/YYYY")}
                            </Typography>
                          )}
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography variant="body1" align="center" sx={{ py: 2 }}>
                Aucun dégât à afficher
              </Typography>
            )}
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button
              onClick={(e) => handleCloseDamageDialog(e as React.MouseEvent)}
              color="primary"
              variant="contained"
              size="large"
              sx={{ minWidth: 120 }}
            >
              Fermer
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }

  // Rendu de la page d'historique général
  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100vw",
        background: "linear-gradient(135deg, #e3f0ff 0%, #f9f9f9 100%)",
        py: { xs: 2, md: 4 },
        px: { xs: 0, md: 0 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 1300,
          mx: "auto",
          boxShadow: 3,
          borderRadius: 4,
          background: "#fff",
          p: { xs: 1.5, sm: 3, md: 4 },
          mt: { xs: 1, md: 3 },
          mb: { xs: 2, md: 4 },
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* En-tête */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 4,
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 0 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <Button
              onClick={() => navigate(canAccessDashboard ? "/vehicules" : "/historique-vehicules")}
              startIcon={<ArrowBackIcon />}
              variant="outlined"
              color="primary"
              sx={{ borderRadius: 2 }}
            >
              {canAccessDashboard ? "Liste des véhicules" : "Retour"}
            </Button>
            <Typography
              variant="h5"
              fontWeight={700}
              sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
            >
              <HistoryIcon sx={{ mr: 1, verticalAlign: "middle" }} /> Historique
              du véhicule {plate}
            </Typography>
            {/* #16 — Dernier conducteur */}
            {(() => {
              const lastAssignment = history?.assignments?.find(a => a.driverFirstName);
              if (lastAssignment) {
                return (
                  <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                    <PersonIcon sx={{ fontSize: 16, verticalAlign: "middle", mr: 0.5 }} />
                    Dernier conducteur: <strong>{lastAssignment.driverFirstName} {lastAssignment.driverLastName}</strong>
                  </Typography>
                );
              }
              return null;
            })()}
          </Box>
        </Box>

        {/* #17 — Coûts Cumulés des Réparations & des Dégradations sans les Entretiens */}
        {repairs.length > 0 && (
          <Card sx={{ mb: 4, borderRadius: 3, boxShadow: 2, border: "2px solid", borderColor: "warning.light" }}>
            <CardHeader
              title="Coûts Cumulés des Réparations & des Dégradations sans les Entretiens"
              titleTypographyProps={{ variant: "h6", fontWeight: 700 }}
              avatar={
                <Avatar sx={{ bgcolor: "warning.main" }}>
                  <EuroIcon />
                </Avatar>
              }
            />
            <CardContent>
              <Typography variant="h3" align="center" fontWeight={800} color="warning.dark">
                {repairs
                  .filter(r => r.repairType !== "entretien")
                  .reduce((sum, r) => sum + (r.invoiceAmount || 0), 0)
                  .toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
              </Typography>
              <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
                Total hors entretiens ({repairs.filter(r => r.repairType !== "entretien").length} réparations)
              </Typography>
              {loadingRepairs && <LinearProgress sx={{ mt: 1 }} />}
            </CardContent>
          </Card>
        )}

        {/* #18 — Réparations mécanique & Entretiens usuels */}
        {repairs.length > 0 && (() => {
          const now = dayjs();
          const currentMonth = now.month();
          const currentYear = now.year();
          const prevMonth = now.subtract(1, "month").month();
          const prevYear = now.subtract(1, "month").year();

          const mecaRepairs = repairs.filter(r => r.repairType === "mecanique");
          const mecaTotal = mecaRepairs.reduce((s, r) => s + (r.invoiceAmount || 0), 0);
          const mecaCurrent = mecaRepairs
            .filter(r => dayjs(r.garageDate).month() === currentMonth && dayjs(r.garageDate).year() === currentYear)
            .reduce((s, r) => s + (r.invoiceAmount || 0), 0);
          const mecaPrev = mecaRepairs
            .filter(r => dayjs(r.garageDate).month() === prevMonth && dayjs(r.garageDate).year() === prevYear)
            .reduce((s, r) => s + (r.invoiceAmount || 0), 0);
          const mecaPctChange = mecaPrev > 0 ? ((mecaCurrent - mecaPrev) / mecaPrev) * 100 : 0;

          const entretienRepairs = repairs.filter(r => r.repairType === "entretien");
          const entretienTotal = entretienRepairs.reduce((s, r) => s + (r.invoiceAmount || 0), 0);
          const entretienCurrent = entretienRepairs
            .filter(r => dayjs(r.garageDate).month() === currentMonth && dayjs(r.garageDate).year() === currentYear)
            .reduce((s, r) => s + (r.invoiceAmount || 0), 0);
          const entretienPrev = entretienRepairs
            .filter(r => dayjs(r.garageDate).month() === prevMonth && dayjs(r.garageDate).year() === prevYear)
            .reduce((s, r) => s + (r.invoiceAmount || 0), 0);
          const entretienPctChange = entretienPrev > 0 ? ((entretienCurrent - entretienPrev) / entretienPrev) * 100 : 0;

          return (
            <Grid container spacing={3} sx={{ mb: 4 }}>
              <Grid sx={{ gridColumn: { xs: "span 12", md: "span 6" } }}>
                <Card sx={{ borderRadius: 3, boxShadow: 2, height: "100%" }}>
                  <CardHeader
                    title="Réparations mécanique"
                    titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
                    avatar={<Avatar sx={{ bgcolor: "#3b82f6" }}><BuildIcon /></Avatar>}
                  />
                  <CardContent>
                    <Typography variant="h4" align="center" fontWeight={700}>
                      {mecaTotal.toLocaleString("fr-FR", { minimumFractionDigits: 2 })} €
                    </Typography>
                    <Typography variant="body2" color="text.secondary" align="center">
                      Total ({mecaRepairs.length} réparations)
                    </Typography>
                    <Divider sx={{ my: 2 }} />
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Typography variant="body2" color="text.secondary">
                        Last period: {mecaPrev.toLocaleString("fr-FR", { minimumFractionDigits: 2 })} €
                      </Typography>
                      <Chip
                        size="small"
                        icon={mecaPctChange <= 0 ? <TrendingDownIcon /> : <TrendingUpIcon />}
                        label={`${mecaPctChange >= 0 ? "+" : ""}${mecaPctChange.toFixed(1)}%`}
                        color={mecaPctChange <= 0 ? "success" : "error"}
                        variant="outlined"
                      />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
              <Grid sx={{ gridColumn: { xs: "span 12", md: "span 6" } }}>
                <Card sx={{ borderRadius: 3, boxShadow: 2, height: "100%" }}>
                  <CardHeader
                    title="Entretiens usuels"
                    titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
                    avatar={<Avatar sx={{ bgcolor: "#10b981" }}><BuildIcon /></Avatar>}
                  />
                  <CardContent>
                    <Typography variant="h4" align="center" fontWeight={700}>
                      {entretienTotal.toLocaleString("fr-FR", { minimumFractionDigits: 2 })} €
                    </Typography>
                    <Typography variant="body2" color="text.secondary" align="center">
                      Total ({entretienRepairs.length} entretiens)
                    </Typography>
                    <Divider sx={{ my: 2 }} />
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Typography variant="body2" color="text.secondary">
                        Last period: {entretienPrev.toLocaleString("fr-FR", { minimumFractionDigits: 2 })} €
                      </Typography>
                      <Chip
                        size="small"
                        icon={entretienPctChange <= 0 ? <TrendingDownIcon /> : <TrendingUpIcon />}
                        label={`${entretienPctChange >= 0 ? "+" : ""}${entretienPctChange.toFixed(1)}%`}
                        color={entretienPctChange <= 0 ? "success" : "error"}
                        variant="outlined"
                      />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          );
        })()}

        {/* #19 — Coûts des Sinistres & Dégradations non couvert par l'assurance */}
        {repairs.length > 0 && (() => {
          const now = dayjs();
          const currentMonth = now.month();
          const currentYear = now.year();
          const prevMonth = now.subtract(1, "month").month();
          const prevYear = now.subtract(1, "month").year();

          // Sinistres = tolerie repairs (carrosserie / sinistres)
          const sinistreRepairs = repairs.filter(r => r.repairType === "tolerie");
          const sinistreTotal = sinistreRepairs.reduce((s, r) => s + (r.invoiceAmount || 0), 0);
          const sinistreCurrent = sinistreRepairs
            .filter(r => dayjs(r.garageDate).month() === currentMonth && dayjs(r.garageDate).year() === currentYear)
            .reduce((s, r) => s + (r.invoiceAmount || 0), 0);
          const sinistrePrev = sinistreRepairs
            .filter(r => dayjs(r.garageDate).month() === prevMonth && dayjs(r.garageDate).year() === prevYear)
            .reduce((s, r) => s + (r.invoiceAmount || 0), 0);
          const sinistrePctChange = sinistrePrev > 0 ? ((sinistreCurrent - sinistrePrev) / sinistrePrev) * 100 : 0;
          const lastSinistre = sinistreRepairs.length > 0 ? sinistreRepairs[0] : null;

          // Dégradations = isDamageRepair repairs (not tolerie)
          const degradRepairs = repairs.filter(r => r.isDamageRepair && r.repairType !== "tolerie");
          const degradTotal = degradRepairs.reduce((s, r) => s + (r.invoiceAmount || 0), 0);
          const degradCurrent = degradRepairs
            .filter(r => dayjs(r.garageDate).month() === currentMonth && dayjs(r.garageDate).year() === currentYear)
            .reduce((s, r) => s + (r.invoiceAmount || 0), 0);
          const degradPrev = degradRepairs
            .filter(r => dayjs(r.garageDate).month() === prevMonth && dayjs(r.garageDate).year() === prevYear)
            .reduce((s, r) => s + (r.invoiceAmount || 0), 0);
          const degradPctChange = degradPrev > 0 ? ((degradCurrent - degradPrev) / degradPrev) * 100 : 0;

          const coutTotalSection = sinistreTotal + degradTotal;

          return (
            <Card sx={{ mb: 4, borderRadius: 3, boxShadow: 2, border: "2px solid", borderColor: "error.light" }}>
              <CardHeader
                title="Coûts des Sinistres & Dégradations non couvert par l'assurance"
                titleTypographyProps={{ variant: "h6", fontWeight: 700 }}
                avatar={<Avatar sx={{ bgcolor: "error.main" }}><CarCrashIcon /></Avatar>}
              />
              <CardContent>
                <Grid container spacing={3}>
                  {/* Sinistres */}
                  <Grid sx={{ gridColumn: { xs: "span 12", md: "span 6" } }}>
                    <Box sx={{ p: 2, bgcolor: "#FEF2F2", borderRadius: 2, height: "100%" }}>
                      <Typography variant="subtitle1" fontWeight={700} color="error.dark" gutterBottom>
                        <ReportProblemIcon sx={{ fontSize: 18, verticalAlign: "middle", mr: 0.5 }} />
                        Sinistres
                      </Typography>
                      <Typography variant="h5" fontWeight={700}>
                        {sinistreTotal.toLocaleString("fr-FR", { minimumFractionDigits: 2 })} €
                      </Typography>
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                          Last period: {sinistrePrev.toLocaleString("fr-FR", { minimumFractionDigits: 2 })} €
                        </Typography>
                        <Chip
                          size="small"
                          icon={sinistrePctChange <= 0 ? <TrendingDownIcon /> : <TrendingUpIcon />}
                          label={`${sinistrePctChange >= 0 ? "+" : ""}${sinistrePctChange.toFixed(1)}%`}
                          color={sinistrePctChange <= 0 ? "success" : "error"}
                          variant="outlined"
                        />
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        {sinistreRepairs.length} sinistre{sinistreRepairs.length > 1 ? "s" : ""}
                      </Typography>
                      {lastSinistre && (
                        <Box sx={{ mt: 2, p: 1.5, bgcolor: "white", borderRadius: 1, border: "1px solid #FECACA" }}>
                          <Typography variant="caption" color="text.secondary">Dernier sinistre</Typography>
                          <Typography variant="body2" fontWeight={600}>
                            {dayjs(lastSinistre.garageDate).format("DD/MM/YYYY")}
                          </Typography>
                          {lastSinistre.responsibleDriverName && (
                            <Typography variant="body2" color="text.secondary">
                              Conducteur: {lastSinistre.responsibleDriverName}
                            </Typography>
                          )}
                        </Box>
                      )}
                    </Box>
                  </Grid>
                  {/* Dégradations */}
                  <Grid sx={{ gridColumn: { xs: "span 12", md: "span 6" } }}>
                    <Box sx={{ p: 2, bgcolor: "#FFF7ED", borderRadius: 2, height: "100%" }}>
                      <Typography variant="subtitle1" fontWeight={700} color="warning.dark" gutterBottom>
                        <WarningIcon sx={{ fontSize: 18, verticalAlign: "middle", mr: 0.5 }} />
                        Dégradations
                      </Typography>
                      <Typography variant="h5" fontWeight={700}>
                        {degradTotal.toLocaleString("fr-FR", { minimumFractionDigits: 2 })} €
                      </Typography>
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                          Last period: {degradPrev.toLocaleString("fr-FR", { minimumFractionDigits: 2 })} €
                        </Typography>
                        <Chip
                          size="small"
                          icon={degradPctChange <= 0 ? <TrendingDownIcon /> : <TrendingUpIcon />}
                          label={`${degradPctChange >= 0 ? "+" : ""}${degradPctChange.toFixed(1)}%`}
                          color={degradPctChange <= 0 ? "success" : "error"}
                          variant="outlined"
                        />
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        {degradRepairs.length} dégradation{degradRepairs.length > 1 ? "s" : ""}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>
                  <Typography variant="h6" fontWeight={700} color="error.dark">
                    Coût total: {coutTotalSection.toLocaleString("fr-FR", { minimumFractionDigits: 2 })} €
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          );
        })()}

        {/* #20 — Contrôles obligatoires */}
        {history?.vehicleInfo && (() => {
          const v = history.vehicleInfo as any;
          const controls = [
            { label: "Contrôle technique", date: v.technicalInspectionDate },
            { label: "CT PL", date: v.technicalInspectionPLDate },
            { label: "Contrôle pollution", date: v.pollutionControlDate },
            { label: "Hayon", date: v.tailgateInspectionDate },
            { label: "Grue", date: v.craneInspectionDate },
            { label: "Extincteurs", date: v.extinguisherInspectionDate },
            { label: "Chronotachygraphe", date: v.tachographInspectionDate },
            { label: "Limiteur de vitesse", date: v.speedLimiterInspectionDate },
            { label: "Groupe frigorifique", date: v.frigoGroupInspectionDate },
            { label: "ATP", date: v.atpCertificateDate },
            { label: "ADR", date: v.adrDate },
          ].filter(c => c.date);

          if (controls.length === 0) return null;

          const getDateColor = (dateStr: string) => {
            const date = dayjs(dateStr);
            const now = dayjs();
            if (date.isBefore(now)) return "error";
            if (date.diff(now, "day") <= 30) return "warning";
            return "success";
          };

          const getDateIcon = (dateStr: string) => {
            const color = getDateColor(dateStr);
            if (color === "error") return <ReportProblemIcon sx={{ color: "#d32f2f" }} />;
            if (color === "warning") return <ScheduleIcon sx={{ color: "#ed6c02" }} />;
            return <CheckCircleIcon sx={{ color: "#2e7d32" }} />;
          };

          return (
            <Card sx={{ mb: 4, borderRadius: 3, boxShadow: 2 }}>
              <CardHeader
                title="Contrôles obligatoires"
                titleTypographyProps={{ variant: "h6", fontWeight: 700 }}
                avatar={<Avatar sx={{ bgcolor: "info.main" }}><VerifiedUserIcon /></Avatar>}
              />
              <CardContent>
                <Grid container spacing={2}>
                  {controls.map((ctrl, idx) => {
                    const color = getDateColor(ctrl.date);
                    const bgMap = { error: "#FEF2F2", warning: "#FFF7ED", success: "#F0FDF4" };
                    const borderMap = { error: "#FECACA", warning: "#FED7AA", success: "#BBF7D0" };
                    return (
                      <Grid key={idx} sx={{ gridColumn: { xs: "span 12", sm: "span 6", md: "span 4" } }}>
                        <Box sx={{
                          p: 2,
                          borderRadius: 2,
                          bgcolor: bgMap[color],
                          border: `1px solid ${borderMap[color]}`,
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                        }}>
                          {getDateIcon(ctrl.date)}
                          <Box>
                            <Typography variant="body2" fontWeight={600}>{ctrl.label}</Typography>
                            <Typography variant="body2" color="text.secondary">
                              {dayjs(ctrl.date).format("DD/MM/YYYY")}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </CardContent>
            </Card>
          );
        })()}

        {/* #21 — Consommation */}
        {history?.vehicleInfo && (() => {
          const v = history.vehicleInfo as any;
          const consoConstructor = v.consumptionFuelConstructor;
          const consoReal = v.consumptionFuelReal;

          return (
            <Card sx={{ mb: 4, borderRadius: 3, boxShadow: 2 }}>
              <CardHeader
                title="Consommation"
                titleTypographyProps={{ variant: "h6", fontWeight: 700 }}
                avatar={<Avatar sx={{ bgcolor: "#8b5cf6" }}><LocalGasStationIcon /></Avatar>}
                action={
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<UploadFileIcon />}
                    component="label"
                    sx={{ borderRadius: 2 }}
                  >
                    Importer Excel
                    <input
                      type="file"
                      accept=".xlsx,.xls"
                      hidden
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file) {
                          console.log("Fichier Excel sélectionné:", file.name);
                          // TODO: Implémenter l'upload
                        }
                      }}
                    />
                  </Button>
                }
              />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid sx={{ gridColumn: { xs: "span 12", sm: "span 6" } }}>
                    <Box sx={{ p: 2, bgcolor: "#F5F3FF", borderRadius: 2, textAlign: "center" }}>
                      <Typography variant="body2" color="text.secondary" gutterBottom>Constructeur</Typography>
                      <Typography variant="h5" fontWeight={700} color="#7c3aed">
                        {consoConstructor ? `${consoConstructor} L/100km` : "- L/100km"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid sx={{ gridColumn: { xs: "span 12", sm: "span 6" } }}>
                    <Box sx={{ p: 2, bgcolor: "#FDF4FF", borderRadius: 2, textAlign: "center" }}>
                      <Typography variant="body2" color="text.secondary" gutterBottom>Réelle</Typography>
                      <Typography variant="h5" fontWeight={700} color="#a21caf">
                        {consoReal ? `${consoReal} L/100km` : "- L/100km"}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          );
        })()}

        {/* Tableau de bord résumé */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid
            sx={{ gridColumn: { xs: "span 12", md: "span 4", lg: "span 4" } }}
          >
            <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
              <CardHeader
                title="Affectations"
                titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
                avatar={
                  <Avatar sx={{ bgcolor: "primary.main" }}>
                    <CalendarIcon />
                  </Avatar>
                }
              />
              <CardContent>
                <Typography variant="h4" align="center" fontWeight={700}>
                  {summary.completedAssignments} / {summary.totalAssignments}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  align="center"
                >
                  Affectations terminées
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid
            sx={{ gridColumn: { xs: "span 12", md: "span 4", lg: "span 4" } }}
          >
            <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
              <CardHeader
                title="Kilométrage"
                titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
                avatar={
                  <Avatar sx={{ bgcolor: "secondary.main" }}>
                    <SpeedIcon />
                  </Avatar>
                }
              />
              <CardContent>
                <Typography variant="h4" align="center" fontWeight={700}>
                  {summary.kilometersTotal} km
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  align="center"
                >
                  Distance totale parcourue
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid
            sx={{ gridColumn: { xs: "span 12", md: "span 4", lg: "span 4" } }}
          >
            <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
              <CardHeader
                title="Dégradations"
                titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
                avatar={
                  <Avatar sx={{ bgcolor: "error.main" }}>
                    <DamageIcon />
                  </Avatar>
                }
              />
              <CardContent>
                <Typography variant="h4" align="center" fontWeight={700}>
                  {summary.activeDamages}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  align="center"
                >
                  Dégradations enregistrées
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Photos d'inspection du véhicule */}
        {history?.inspectionPhotos && Object.values(history.inspectionPhotos).some(p => p) && (
          <Card sx={{ mb: 4, borderRadius: 3, boxShadow: 2 }}>
            <CardHeader
              title="Photos du véhicule"
              titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
              avatar={
                <Avatar sx={{ bgcolor: "info.main" }}>
                  <CameraAltIcon />
                </Avatar>
              }
            />
            <CardContent>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, justifyContent: "center" }}>
                {[
                  { key: "front", label: "Avant", icon: <DriveEtaIcon /> },
                  { key: "back", label: "Arrière", icon: <ArrowBackIcon sx={{ transform: "rotate(180deg)" }} /> },
                  { key: "driverSide", label: "Côté conducteur", icon: <MeetingRoomIcon /> },
                  { key: "passengerSide", label: "Côté passager", icon: <MeetingRoomIcon sx={{ transform: "scaleX(-1)" }} /> },
                  { key: "interior", label: "Intérieur", icon: <AirlineSeatReclineNormalIcon /> },
                  { key: "engine", label: "Moteur", icon: <BuildIcon /> },
                ].map(({ key, label, icon }) => {
                  const photo = history.inspectionPhotos?.[key as keyof typeof history.inspectionPhotos];
                  if (!photo) return null;
                  return (
                    <Box
                      key={key}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: 150,
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1 }}>
                        {icon}
                        <Typography variant="subtitle2" fontWeight={600}>
                          {label}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          width: 140,
                          height: 100,
                          borderRadius: 2,
                          overflow: "hidden",
                          border: "2px solid",
                          borderColor: "primary.light",
                          cursor: "pointer",
                          "&:hover": {
                            borderColor: "primary.main",
                            transform: "scale(1.02)",
                          },
                          transition: "all 0.2s ease",
                        }}
                        onClick={() => window.open(photo, "_blank")}
                      >
                        <img
                          src={photo}
                          alt={label}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </CardContent>
          </Card>
        )}

        {/* Liste des paires de processus */}
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Processus d'entrée/sortie ({filteredAndSortedProcessPairs.length}/{processPairs.length})
          </Typography>
          
          {/* Barre de recherche et filtres */}
          {processPairs.length > 0 && (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2 }}>
              <TextField
                placeholder="Rechercher (chauffeur, mission, créateur...)"
                value={processSearch}
                onChange={(e) => setProcessSearch(e.target.value)}
                size="small"
                sx={{ flex: 1, minWidth: 200 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                  endAdornment: processSearch && (
                    <InputAdornment position="end">
                      <ClearIcon 
                        fontSize="small" 
                        sx={{ cursor: "pointer" }}
                        onClick={() => setProcessSearch("")}
                      />
                    </InputAdornment>
                  ),
                }}
              />
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Statut</InputLabel>
                <Select
                  value={processStatusFilter}
                  label="Statut"
                  onChange={(e) => setProcessStatusFilter(e.target.value)}
                >
                  <MenuItem value="all">Tous</MenuItem>
                  <MenuItem value="completed">Complété</MenuItem>
                  <MenuItem value="in_progress">En cours</MenuItem>
                </Select>
              </FormControl>
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Trier par</InputLabel>
                <Select
                  value={processSort}
                  label="Trier par"
                  onChange={(e) => setProcessSort(e.target.value as typeof processSort)}
                >
                  <MenuItem value="date_desc">Date (récent)</MenuItem>
                  <MenuItem value="date_asc">Date (ancien)</MenuItem>
                  <MenuItem value="driver">Chauffeur</MenuItem>
                  <MenuItem value="status">Statut</MenuItem>
                </Select>
              </FormControl>
            </Box>
          )}
        </Box>

        {filteredAndSortedProcessPairs.length > 0 ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {filteredAndSortedProcessPairs.map((pair) => (
              <Card
                key={pair.id}
                sx={{
                  borderRadius: 2,
                  boxShadow: 2,
                  overflow: "visible",
                  border: "1px solid",
                  borderColor:
                    pair.status === "Complété"
                      ? "success.light"
                      : "primary.light",
                }}
              >
                {/* En-tête de la paire */}
                <CardHeader
                  title={`Affectation: ${pair.purpose}`}
                  subheader={
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        {formatDate(pair.date)} {pair.entryProcess?.time ? `à ${pair.entryProcess.time}` : ""} - {pair.driverName}
                      </Typography>
                      {(pair.entryProcess as any)?.createdByName && (
                        <Typography variant="caption" color="text.secondary">
                          Créé par: <strong>{(pair.entryProcess as any).createdByName}</strong>
                        </Typography>
                      )}
                    </Box>
                  }
                  avatar={
                    <Avatar>
                      <PersonIcon />
                    </Avatar>
                  }
                  action={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Chip
                        label={pair.status}
                        color={
                          pair.status === "Complété" ? "success" : "primary"
                        }
                        size="small"
                      />
                    </Box>
                  }
                  onClick={() =>
                    navigate(
                      `/vehicules/historique/${plate}/processus/${pair.id}`
                    )
                  }
                  sx={{ cursor: "pointer" }}
                />
              </Card>
            ))}
          </Box>
        ) : processPairs.length > 0 ? (
          <Typography color="text.secondary" align="center">
            Aucun processus ne correspond à votre recherche.
          </Typography>
        ) : (
          <Typography color="text.secondary" align="center">
            Aucun historique d'affectation trouvé pour ce véhicule.
          </Typography>
        )}
      </Box>

      {/* Dialog pour afficher les dégâts regroupés */}
      <Dialog
        open={damageDialogOpen}
        onClose={(e) => handleCloseDamageDialog(e as React.MouseEvent)}
        maxWidth="md"
        fullWidth
        keepMounted={false}
        disablePortal={false}
        disableEscapeKeyDown={false}
        disableEnforceFocus={false}
        disableAutoFocus={false}
        disableRestoreFocus={false}
        PaperProps={{
          sx: {
            maxHeight: "80vh",
            minWidth: { xs: "90vw", sm: "70vw", md: "50vw" },
            overflow: "auto",
          },
        }}
        TransitionProps={{
          timeout: 300,
        }}
        sx={{
          zIndex: 1500,
          backdropFilter: "blur(2px)",
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "primary.main",
            color: "white",
            fontWeight: "bold",
            px: 3,
            py: 2,
          }}
        >
          {dialogTitle}
        </DialogTitle>
        <DialogContent dividers sx={{ p: 3 }}>
          {selectedDamages && selectedDamages.length > 0 ? (
            <List>
              {selectedDamages.map((damage, idx) => (
                <ListItem
                  key={idx}
                  divider={idx < selectedDamages.length - 1}
                  sx={{
                    py: 2,
                    borderLeft: `4px solid ${getDamageColor(
                      damage.damageType
                    )}`,
                    my: 1,
                    borderRadius: 1,
                    bgcolor: `${getDamageColor(damage.damageType)}10`,
                  }}
                >
                  <ListItemIcon>
                    <Box
                      sx={{
                        bgcolor: `${getDamageColor(damage.damageType)}30`,
                        p: 1,
                        borderRadius: "50%",
                        color: getDamageColor(damage.damageType),
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {getDamageIcon(damage.damageType)}
                    </Box>
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: "bold" }}
                      >
                        {getDamageLabel(damage.damageType)} #{idx + 1}
                      </Typography>
                    }
                    secondary={
                      <>
                        <Typography
                          variant="body2"
                          component="span"
                          display="block"
                          sx={{ mt: 1 }}
                        >
                          Position: x={damage.position?.x.toFixed(2)}, y=
                          {damage.position?.y.toFixed(2)}
                        </Typography>
                        <Box
                          sx={{
                            mt: 1.5,
                            mb: 1,
                            p: 1,
                            bgcolor: "info.light",
                            color: "white",
                            borderRadius: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <PersonIcon sx={{ mr: 1, fontSize: 20 }} />
                          <Typography
                            variant="body1"
                            component="span"
                            sx={{ fontWeight: "bold" }}
                          >
                            ID Conducteur: {damage.driverId || "Non spécifié"}
                          </Typography>
                        </Box>
                        {damage.date && (
                          <Typography
                            variant="body2"
                            component="span"
                            display="block"
                          >
                            Date: {dayjs(damage.date).format("DD/MM/YYYY")}
                          </Typography>
                        )}
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body1" align="center" sx={{ py: 2 }}>
              Aucun dégât à afficher
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={(e) => handleCloseDamageDialog(e as React.MouseEvent)}
            color="primary"
            variant="contained"
            size="large"
            sx={{ minWidth: 120 }}
          >
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default VehicleHistoryPage;
